/** All current study photos in /public/images/clinical/ctsi (keep in sync with that folder). */
export const CLINICAL_CTSI_IMAGES: string[] = [
  "/images/clinical/ctsi/study-02.webp",
  "/images/clinical/ctsi/study-03.webp",
  "/images/clinical/ctsi/study-04.webp",
  "/images/clinical/ctsi/study-05.webp",
  "/images/clinical/ctsi/study-07.webp",
];
